import type {NavigationDirection} from '../navigationDirection';

export const TRANSITION_BEHAVIOR_TYPE = {
    IGNORE: 'ignore',
    ANIMATE: 'animate',
} as const;

export type TransitionBehavior =
    | {type: typeof TRANSITION_BEHAVIOR_TYPE.IGNORE}
    | {type: typeof TRANSITION_BEHAVIOR_TYPE.ANIMATE; direction: NavigationDirection};
